<template>
	<div class="changepassword">
		<div class="titles">个人中心>修改密码</div>
		<div class="passbox">
			<div class="passbox1">
				<div class="titles2">您必须回答安全问题才能修改密码</div>
				<div class="problem" v-if="userall!=null">
					<span>安全问题：</span>
					{{userall.questionName}}
				</div>
				<div class="problem">
					<span>答案：</span>
					<input type="text" v-model.lazy="question" placeholder="请填写您的安全问题答案" />
				</div>
				<div class="problem">
					<span>新密码：</span>
					<input type="password" v-model.lazy="passward" placeholder="请填写您的新密码" />
				</div>
				<div class="problem">
					<span>确认密码：</span>
					<input type="password" v-model.lazy="passward2" placeholder="请确认您的新密码" />
				</div>
				<div class="btnbox">
					<button @click="submit">确定</button>
					<button @click="back">取消</button>
				</div>
			</div>
		</div>
		<popup ref="popup" :types="messagetype" :message="message"></popup>
	</div>
</template>

<script>
	import axios from 'axios'
	import popup from '../popups/popup.vue'
	export default {
		name: 'changepassword',
		components:{
			popup
		},
		data(){
			return{
				message: '', //提示消息
				messagetype: '',
				question:'',
				passward:'',
				passward2:'',
				userall:null
			}
		}
		,
		created() {
			this.getuserList()
		},
		methods:{
			getuserList(){
				let token = this.$store.state.token //token
				let userid = this.$store.state.userid //id
				axios({
					url: this.$api.commonUrl + 'student/' + userid,
					method: 'GET',
					headers: {
						"Authorization": "Bearer " + token
					}
				}).then(res => {
					if (res.data.code == '200') {
						this.userall = res.data.data
					}
				}).catch(err => {
					console.log(err)
				})
			},
			submit(){
				if(this.changeinput()){
					//修改密码接口
					axios({
						method: 'post',
						url: this.$api.commonUrl + 'student/pwd',
						data:{
							identifier: this.userall.userAuth.identifier,
							passWord: this.passward
						},
						responseType: "json"
					}).then(res => {
						if (res.data.code == '200') {
							this.messagetype = 'success'
							this.message = '密码修改成功'
							this.$refs.popup.popupshow()
							setTimeout(()=>{
								this.$router.back()
							},1000)
						}else{
							his.messagetype = 'error'
							this.message = res.data.message
							this.$refs.popup.popupshow()
						}
					}).catch(err =>{
						console.log("insert", err)
					})
				}else{
					this.$refs.popup.popupshow()
				}
			},
			back(){
				this.$router.back()
			},
			changeinput(){
				if(this.question.length===0){
					this.messagetype = 'warning'
					this.message = '请输入您的安全问题答案'
					return false
				}else if(this.passward.length===0){
					this.messagetype = 'warning'
					this.message = '请输入您的新密码'
					return false
				}else if(this.passward2.length===0){
					this.messagetype = 'warning'
					this.message = '请确认您的密码'
					return false
				}else if(this.passward != this.passward2){
					this.messagetype = 'error'
					this.message = '两次密码不一致'
					return false
				}else if(this.question != this.userall.answer){
					this.messagetype = 'error'
					this.message = '您输入的安全问题答案不正确'
					return false
				}else{
					return true
				}
			}
		}
	}
</script>

<style scoped>
	.changepassword .titles{
		height: 2rem;
		font-size: 1.1rem;
		line-height: 2rem;
		color: #FFFFFF;
		padding-left: 1rem;
		background: #a2693f;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
	}
	.changepassword .titles2{
		height: 2rem;
		font-size: 1.1rem;
		line-height: 2rem;
		color: #5f3519;
		padding: 0.5rem;
		border-bottom: 1px dashed #5f3519;
	}
	.changepassword .passbox{
		background: rgba(255,255,255,0.4);
		width: 100%;
		height: 46rem;
		margin-top: 0.5rem;
		position: relative;
	}
	.changepassword .passbox1{
		position: absolute;
		top: 0.5rem;
		left: 0.5rem;
		right: 0.5rem;
		bottom: 0.5rem;
		background: #FFFFFF;
	}
	.changepassword .problem{
		padding: 0.5rem;
		height: 3rem;
		padding-left: 2rem;
		line-height: 3rem;
		font-size: 1rem;
		color: #cea57d;
	}
	.changepassword .problem span{
		color: #5f3519;
		position: relative;
		display: inline-block;
		width: 7rem;
		height: 3rem;
	}
	.changepassword .problem span::before{
		content: "*";
		position: absolute;
		width: 1rem;
		height: 1rem;
		line-height: 1.4rem;
		text-align: center;
		left: -1.5rem;
		margin: auto;
		top: 0;
		bottom: 0;
		color: #a73a29;
		font-size: 1rem;
	}
	.changepassword .problem input{
		outline-style: none;
		border-radius: 0px;
		height: 2rem;
		border: 1px solid #c8c8c8;
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		width: 15rem;
		font-size: 1rem;
	}
	.changepassword .btnbox{
		position: absolute;
		bottom: 5rem;
		margin-left: 2rem;
	}
	.changepassword .btnbox button{
		background: #a73a29;
		width: 13rem;
		height: 2.8rem;
		color: #FFFFFF;
		border: none;
		margin-right: 5rem;
		font-size: 1.1rem;
		line-height: 2.8rem;
		text-align: center;
	}
</style>
